import { createSelector } from "@ngrx/store";
import { selectDataSlice } from "./data-slice.selector";

export const selectAdministrationMethods = createSelector(selectDataSlice, (state) => state.administrationMethods);
